import { createContext, useContext, useState, FC, ReactNode } from "react";

interface TooltipPinContextValue {
  pinnedTooltipId: string | null;
  pinTooltip: (id: string) => void;
  unpinTooltip: () => void;
  isPinned: (id: string) => boolean;
  hasAnyPinned: () => boolean;
}

const TooltipPinContext = createContext<TooltipPinContextValue | undefined>(undefined);

export const TooltipPinProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [pinnedTooltipId, setPinnedTooltipId] = useState<string | null>(null);

  const pinTooltip = (id: string) => {
    setPinnedTooltipId(id);
  };

  const unpinTooltip = () => {
    setPinnedTooltipId(null);
  };

  const isPinned = (id: string) => {
    return pinnedTooltipId === id;
  };

  const hasAnyPinned = () => {
    return pinnedTooltipId !== null;
  };

  return (
    <TooltipPinContext.Provider
      value={{
        pinnedTooltipId,
        pinTooltip,
        unpinTooltip,
        isPinned,
        hasAnyPinned,
      }}
    >
      {children}
    </TooltipPinContext.Provider>
  );
};

export const useTooltipPin = () => {
  const context = useContext(TooltipPinContext);
  if (!context) {
    throw new Error("useTooltipPin must be used within a TooltipPinProvider");
  }
  return context;
};
